import React from 'react';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-71">
      <div className="absolute inset-0 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-72" />
      <div className="relative bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden" data-id="element-73">
        <div className="flex items-center justify-between p-4 border-b border-stone-200" data-id="element-74">
          <h3 className="text-xl font-bold text-[#1e3a5f]" data-id="element-75">{title}</h3>
          <button onClick={onClose} className="p-2 hover:bg-stone-100 rounded-full transition-colors" data-id="element-76">
            <X className="h-5 w-5 text-slate-500" data-id="element-77" />
          </button>
        </div>
        <div className="p-6 overflow-y-auto max-h-[60vh] text-slate-700 text-sm leading-relaxed" data-id="element-78">
          {children}
        </div>
      </div>
    </div>;
}
interface LegalModalsProps {
  showPrivacy: boolean;
  showTerms: boolean;
  onClosePrivacy: () => void;
  onCloseTerms: () => void;
}
export function LegalModals({
  showPrivacy,
  showTerms,
  onClosePrivacy,
  onCloseTerms
}: LegalModalsProps) {
  return <>
      <Modal isOpen={showPrivacy} onClose={onClosePrivacy} title="Política de Privacidad" data-id="element-79">
        <div className="space-y-4" data-id="element-80">
          <p data-id="element-81">
            <strong data-id="element-82">Última actualización:</strong> Enero 2024
          </p>

          <h4 className="font-bold text-[#1e3a5f]" data-id="element-83">
            1. Información que Recopilamos
          </h4>
          <p data-id="element-84">
            Recopilamos información personal que nos proporcionas
            voluntariamente al realizar una compra, incluyendo: nombre, correo
            electrónico y datos de pago procesados de forma segura por terceros.
          </p>

          <h4 className="font-bold text-[#1e3a5f]" data-id="element-85">2. Uso de la Información</h4>
          <p data-id="element-86">Utilizamos tu información para:</p>
          <ul className="list-disc pl-5 space-y-1" data-id="element-87">
            <li data-id="element-88">Procesar tu compra y entregar el producto digital</li>
            <li data-id="element-89">Enviarte actualizaciones relacionadas con tu compra</li>
            <li data-id="element-90">Responder a tus consultas de soporte</li>
          </ul>

          <h4 className="font-bold text-[#1e3a5f]" data-id="element-91">3. Protección de Datos</h4>
          <p data-id="element-92">
            No vendemos, intercambiamos ni transferimos tu información personal
            a terceros. Implementamos medidas de seguridad para proteger tu
            información.
          </p>

          <h4 className="font-bold text-[#1e3a5f]" data-id="element-93">4. Cookies</h4>
          <p data-id="element-94">
            Utilizamos cookies para mejorar tu experiencia en nuestro sitio.
            Puedes desactivarlas en tu navegador.
          </p>

          <h4 className="font-bold text-[#1e3a5f]" data-id="element-95">5. Contacto</h4>
          <p data-id="element-96">
            Para cualquier consulta sobre privacidad, contáctanos a través de
            nuestros canales oficiales.
          </p>
        </div>
      </Modal>

      <Modal isOpen={showTerms} onClose={onCloseTerms} title="Términos y Condiciones" data-id="element-97">
        <div className="space-y-4" data-id="element-98">
          <p data-id="element-99">
            <strong data-id="element-100">Última actualización:</strong> Enero 2024
          </p>

          <h4 className="font-bold text-[#1e3a5f]" data-id="element-101">
            1. Aceptación de Términos
          </h4>
          <p data-id="element-102">
            Al comprar "No Me Alcanza", aceptas estos términos y condiciones en
            su totalidad.
          </p>

          <h4 className="font-bold text-[#1e3a5f]" data-id="element-103">2. Producto Digital</h4>
          <p data-id="element-104">
            El producto consiste en una guía digital (PDF) con plantillas
            imprimibles. La entrega es inmediata vía correo electrónico tras
            confirmar el pago.
          </p>

          <h4 className="font-bold text-[#1e3a5f]" data-id="element-105">3. Uso Personal</h4>
          <p data-id="element-106">
            El contenido es para uso personal únicamente. Queda prohibida la
            reproducción, distribución o reventa del material sin autorización
            expresa.
          </p>

          <h4 className="font-bold text-[#1e3a5f]" data-id="element-107">4. Resultados</h4>
          <p data-id="element-108">
            Los resultados financieros dependen de la aplicación individual del
            método. No garantizamos resultados específicos ya que cada situación
            es única.
          </p>

          <h4 className="font-bold text-[#1e3a5f]" data-id="element-109">5. Política de Reembolso</h4>
          <p data-id="element-110">
            Debido a la naturaleza digital del producto, no se aceptan
            devoluciones una vez entregado el material. Te recomendamos leer
            toda la información antes de comprar.
          </p>

          <h4 className="font-bold text-[#1e3a5f]" data-id="element-111">6. Modificaciones</h4>
          <p data-id="element-112">
            Nos reservamos el derecho de modificar estos términos. Los cambios
            serán efectivos inmediatamente después de su publicación.
          </p>

          <h4 className="font-bold text-[#1e3a5f]" data-id="element-113">7. Contacto</h4>
          <p data-id="element-114">
            Para consultas sobre estos términos, contáctanos a través de
            nuestros canales oficiales.
          </p>
        </div>
      </Modal>
    </>;
}